import { render } from "./AppointmentListItem.vue?vue&type=template&id=c99a33a0"
import script from "./AppointmentListItem.vue?vue&type=script&lang=js"
export * from "./AppointmentListItem.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/star-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__